exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-panelMessage{position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden;pointer-events:none;white-space:normal}.bi-common-panelMessage__inner{position:absolute;top:50%;left:0;width:100%;transform:translateY(-50%);text-align:center}[dir=rtl] .bi-common-panelMessage__inner{left:auto;right:0}.bi-common-panelMessage__contents{pointer-events:all;display:inline-block}", ""]);

// exports
